import { GuardsService } from './../services/guards/guards.service';
import DashboardLayout from '../layouts/dashboard/dashboard.layout';
import BuildingsPage from '../pages/buildings/buildings.page';
import ShopPage from '../pages/shop/shop.page';
import LoginPage from '../pages/login/login.page';
import CreateAccountPage from '../pages/create-account/login.page';
import StatisticsPage from '../pages/statistics/statistics.page';
import TasksPage from '../pages/tasks/tasks.page';
import EmployeeDetailsPage from '../pages/employee-details/employee-details.page';
import EmployeesPage from '../pages/employees/employess.page';
import PaymentOverviewPage from '../pages/payment-overview/payment-overview.page';
import PaymentDetailsPage from '../pages/payment-details/payment-details.page';
import PaymentHistoryPage from '../pages/payment-history/payment-history.page';
import RatingsPage from '../pages/ratings/ratings.page';
const guardsService: GuardsService = new GuardsService();


export default [
    {
      path: '/login',
      title: 'Login',
      component: LoginPage,
      canActivate: [guardsService.isNotAuthorized],
    },
    {
      path: '/create-account',
      title: 'Create account',
      component: CreateAccountPage,
      canActivate: [guardsService.isNotAuthorized],
    },
    {
      path: '/scanning',
      title: 'Tasks',
      component: TasksPage,
    },
    {
      path: '/rating/:recordtaskid',
      title: 'Ratings',
      component: RatingsPage,
    },
    {
      path: '/',
      canActivate: [guardsService.isAuthorized],
      component: DashboardLayout,
      routes: [
        {
          path: '/buildings',
          title: 'Buildings',
          component: BuildingsPage,
        },
        {
          path: '/employee/details/:id',
          title: 'Employee details',
          component: EmployeeDetailsPage,
        },
        {
          path: '/employees',
          title: 'Employees',
          component: EmployeesPage,
        },
        {
          path: '/shop',
          title: 'Shop',
          component: ShopPage,
        },
        {
          path: '/statistics/:id',
          title: 'Statistics',
          component: StatisticsPage,
        },
        {
          path: '/payment/overview',
          title: 'payment-overview',
          component: PaymentOverviewPage,
        },
        {
          path: '/payment/details',
          title: 'payment-details',
          component: PaymentDetailsPage,
        },
        {
          path: '/payment/history',
          title: 'payment-history',
          component: PaymentHistoryPage,
        },
        {
          path: '*',
          redirect: '/buildings',
        },
      ]
    },
    {
      path: '*',
      redirect: '/buildings',
    },
];